


































import EnqueueIcon from "bootstrap-icons/icons/bookmark-plus.svg";
import DequeueIcon from "bootstrap-icons/icons/bookmark-dash.svg";
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { FeedEntry } from "@/store/feed";
import { QueueEntryStatus, EnqueueAction, DequeueAction } from "@/store/queue";

const { Getter, Action } = namespace("queue");

@Component({
  components: {
    EnqueueIcon,
    DequeueIcon
  }
})
export default class QueueButton extends Vue {
  @Prop({ required: true }) entry!: FeedEntry;

  @Getter getStatusById!: (id: string) => QueueEntryStatus;

  @Action enqueue!: (payload: EnqueueAction) => Promise<void>;
  @Action dequeue!: (payload: DequeueAction) => Promise<void>;

  get status() {
    return this.getStatusById(this.entry.id).status;
  }

  get enabled() {
    switch (this.status) {
      case "never-queued":
      case "dequeued":
      case "enqueued":
      case "enqueue-failed":
      case "dequeue-failed":
        return true;
      case "enqueue-pending":
      case "dequeue-pending":
        return false;
    }

    throw new Error(`Invalid status value "${this.status}"`);
  }

  get displayStatus() {
    switch (this.status) {
      case "never-queued":
      case "dequeued":
      case "enqueue-failed":
        return "save";
      case "enqueue-pending":
        return "saving";
      case "enqueued":
      case "dequeue-failed":
        return "unsave";
      case "dequeue-pending":
        return "unsaving";
    }

    throw new Error(`Invalid status value "${this.status}"`);
  }

  toggle() {
    const status = this.displayStatus;
    if (status === "save") {
      this.enqueue({ entry: this.entry });
    } else if (status === "unsave") {
      this.dequeue({ id: this.entry.id });
    } else {
      throw new Error("Cannot toggle queue status during in-flight operation");
    }
  }
}
